import Vue from 'vue';
import Vuelidate from 'vuelidate';

Vue.use(Vuelidate);
Vue.config.productionTip = false;

// components
import ChoosePeriod from '../vue/components/choose-plan/ChoosePeriod.vue';
import FollowUs from '../vue/components/common/FollowUs.vue';
import PlanCards from '../vue/components/choose-plan/PlanCards.vue';

export default {
  init() {
    new Vue({
        el: '#choose-plan',
        components: {
            ChoosePeriod,
            PlanCards,
        },
        data: {
            choosePlanStatusPeriod: 'annual',
        },
        mounted () {
        },
        updated () {
        },
    });

    new Vue({
        render (createElement) {
            return createElement(FollowUs);
        },
    }).$mount('#vue-follow-us');
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js